import Counter from "./Counter";
import {Link} from 'react-router-dom'
import {motion} from 'framer-motion'
import {baseurl} from "../../../services/services";


const Concertcard = ({img,title}) => {

   let txt= function stripTags(text) {
        const stripped= text.replace(/<[^>]+>/g, '');
       if (stripped.length <= 200) {
           return stripped;
       }
       return text.substr(0, 200 ) + '...';
    }






    return (
        <>

            <motion.div className='column is-12-mobile is-6-tablet  is-12-desktop' variants={{
                hidden: {scale: 0},
                visible: {scale: 1, opacity: 1}
            }}>
                <div
                    className='card pt-5 mx-auto is-flex is-flex-direction-column  is-flex-wrap-wrap   is-align-content-center is-justify-content-end borderrad1  backgroundadj p-1  '
                    style={{height: '31rem', backgroundImage: `url(${baseurl}/${img})`}}>

                    <button  className='button is-align-self-flex-end  mx-auto clrone kook has-text-white noborder  concertcardbutton has-text-weight-bold '
                          >
                                 {title}
                              </button>





                </div>


            </motion.div>


        </>
    )
}

export default Concertcard;